import React, { useState } from 'react'
import styles from './styles.module.css'
import { parse } from 'papaparse'
import { CloudUpload } from '@mui/icons-material'
import HelpIcon from '@mui/icons-material/Help';
import InfoModal from '../modals/InfoModal';

function ImportCSV({ setData }) {
  const [fileName, setFileName] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  function drop(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    readCSVFile(file);
  }

  function select() {
    var files = document.querySelector('#file-upload').files;
    if (files.length === 0) {
      return;
    }
    readCSVFile(files[0]);
  }

  async function readCSVFile(file) {
    if (file.type !== 'text/csv') {
      alert('Only CSV files are allowed.');
      return;
    }

    setFileName(file.name);
    const csvText = await file.text();
    const csvData = parse(csvText, { header: true, skipEmptyLines: true }).data;
    setData(csvData);
  }

  return (
    <div className={styles.container}>
      <HelpIcon className={styles.help} onClick={() => setIsVisible(true)} />
      <label htmlFor="file-upload" className={styles.box}
        onDragOver={(e) => e.preventDefault()}
        onDrop={drop}>
        <input type='file' accept='.csv' id='file-upload' onChange={select} />
        <CloudUpload sx={{ fontSize: '50px' }} />
        <span>Upload CSV</span>
      </label>
      <span>{fileName}</span>

      <InfoModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        title={'.csv Instructions'}
        infoText={"Upload a .csv file (not .xlxs, need to select 'Save As' .csv in Excel) with columns 'firstName', 'lastName', and 'phoneNumber'. Values are required for 'firstName' and 'lastName'."} />
    </div>
  )
}

export default ImportCSV